module.exports = __webpack_public_path__ + "static/img/blog-view-demo.38b058b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/news/blog-view-demo.png
// module id = bzZi
// module chunks = 150